import {
  ApiResponse,
  GetNotificationsParams,
  MyNotificationDto,
  Notification,
} from "@/types";
import { filterParams } from "@/utils/filterParams";
import api from "./api";

export async function getNotifications(params?: GetNotificationsParams) {
  const res = await api.get<ApiResponse<Notification[]>>(`/notification`, {
    params: filterParams(params || {}),
  });
  return res.data;
}

export async function deleteNotification(id: number) {
  const res = await api.delete(`/notification/${id}/delete`);
  return res.data;
}

export async function createNotification(formData: FormData) {
  const res = await api.post(`/notification`, formData, {
    timeout: 60000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function getNotificationById(id: number) {
  const res = await api.get<ApiResponse<Notification>>(`/notification/${id}`);
  return res.data;
}

export async function updateNotification(id: number, formData: FormData) {
  const res = await api.patch(`/notification/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function getNotificationUnreadCount() {
  const res = await api.get<ApiResponse<number>>(`/notification/unread-count`);
  return res.data;
}

export async function getMyNotification(params: GetNotificationsParams) {
  const res = await api.get<ApiResponse<MyNotificationDto[]>>(
    `/notification/my-notification`,
    {
      params: filterParams(params || {}),
    },
  );
  return res.data;
}

export async function markAsRead(ids: number[]) {
  const res = await api.post<ApiResponse<Notification>>(
    `/notification/mark-as-read`,
    {
      ids,
    },
  );
  return res.data;
}

export async function markAllAsRead() {
  const res = await api.post<ApiResponse<Notification>>(
    `/notification/mark-all-as-read`,
  );
  return res.data;
}

export async function getMyNotificationDetail(id: number) {
  const res = await api.get<ApiResponse<MyNotificationDto>>(
    `/notification/my-notification/${id}`,
  );
  return res.data;
}
